import { FEATURES_INFO } from './constants'

export default {
  getFeatures() {
    return feature => {
      return (
        FEATURES_INFO[feature] ?? {
          title: feature,
          description: '',
          icon: 'file',
          color: '#6C69FF',
          lightColor: '#D5D4FF'
        }
      )
    }
  }
}
